import { FormattedMessage } from 'react-intl';
import { OrderType, getOrderTypeTranslationId } from '@synergy/models';
import { PoolSelect, useFilter } from '@synergy/components';
import { ReactNode } from 'react';

export interface StatusFilterProps {
    type?: OrderType[];
}

export const OrderTypeFilter = (props: StatusFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (status?: OrderType) => {
        filter.delete('type');
        if (status) {
            filter.set('type', status);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (typeValue: unknown): ReactNode => {
        if (typeof typeValue !== 'string') {
            return '';
        }

        const type = Object.keys(OrderType)
            .map(key => key as keyof typeof OrderType)
            .find(key => OrderType[key] === typeValue);
        return <FormattedMessage id={'app.orderType.' + type?.toLowerCase()} />;
    };

    registerFilterMap('type', getDisplayValue);

    const salesOrderTypeOptions = Object.values(OrderType)
        .filter(orderType => orderType !== OrderType.SingleInquiry && orderType !== OrderType.Anonymous)
        .map(value => {
            return {
                value,
                displayValue: <FormattedMessage id={getOrderTypeTranslationId(value)} />,
            };
        });

    return (
        <PoolSelect
            displayEmpty={true}
            name="type"
            label={<FormattedMessage id="app.table.column.type" />}
            fullWidth={true}
            value={filter.get('type')}
            onValueChange={onSelected}
            noSorting={true}
            options={salesOrderTypeOptions}
        />
    );
};
